import api from '../../api/nodeBackApi';

export const createFirstCheckoutSession = async (paymentConfig) => {

  try {
    const response = await api.post('/api/management/customers/createWithPayment', paymentConfig);
    
    console.log('Pago configurado exitosamente.');
    return response.data;
  } catch (error) {
    console.error("Error al configurar el pago:", error);
    throw error;
  }
};